/*
 * Lib Module InputAddons.js
 */
class InputAddon extends LibModule {
    DOMReady() {

        // all the input types
        var inputTypes = 'div.input-group input[type="text"], div.input-group input[type="password"], div.input-group input[type="email"], div.input-group textarea, div.input-group select';

        $(document).on({
            focus: function() {
                $(this).closest('.input-control').addClass('input-focussed');
            },
            blur: function() {
                $(this).closest('.input-control').removeClass('input-focussed');
            }
        }, inputTypes);

        $(document).on('click', '.input-prefix, .input-suffix', function() {
            let checkAttr = ($(this).hasClass('input-prefix')) ? 'data-prefix-no-focus' : 'data-suffix-no-focus';
            if ($(this).closest('div[' + checkAttr + ']').length === 0) {
                $(this).parent().find('input:first, textarea:first, select:first').not(':disabled').focus();
            }
        });

    }
}

Lib.InputAddon = new InputAddon;
